
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import scroll from '@/mixins/scroll';
import Address from '@/views/shelf/components/address.vue'
import { getStoreFullGift, addGift, updateGift } from '@/api/ccx'

interface OrderParamsDTO {
  companyId: string;
  partnerCompanyId: string;
  storeId?: string;
  orderId?: string;
  receiveMobile?: string;
  goodsName?: string;
  receiveMan?: string;
  orderStatus?: number | string;
  payStatus?: number | string;
  pageSize: number;
  pageIndex: number;
}

@Component({
  name: 'SalesPromotion',
  components: {
    Address
  }
})
export default class SalesPromotion extends Mixins(scroll) {
  @Getter partnerCompanyId!: string;
  @Getter companyId!: string;
  @Getter whiteStrips!: number;
  // @Getter topSafetyHeight!: number
  isAdd = false;
  showDetail = false; // 展示明细
  error = false;
  isGetList = false;

  refreshing = false;
  loading = false;
  finished = false;
  params: OrderParamsDTO = {
    companyId: '',
    partnerCompanyId: '',
    // 订单编号
    orderId: '',
    // 手机号
    receiveMobile: '',
    // 商品名称
    goodsName: '',
    // 收货人姓名
    receiveMan: '',
    pageIndex: 1,
    pageSize: 20,
  };
  orderList = [];
  controller: any;
  clickedItemIndex = 0;
  isActivated = false;
  dataDetail: any = {}; // 明细数据

  created() {
    // this.params.partnerCompanyId = this.partnerCompanyId;
    // this.params.companyId = this.companyId;
    this.getOrderList();
  }

  mounted() {
    this.$addScrollListener('.van-tabs__content');
    // this.getOrderList()
  }

  deactivated() {
    this.$removeScrollListener();
  }
  openShowDetail(data: any) {
    this.isAdd = false;
    this.showDetail = true;
    this.dataDetail = data;
  }

  addActivity () {
    this.isAdd = true;
    this.showDetail = true;
    this.dataDetail = {
      fullGiftOrderMoney: 0,
      fullGiftMode: 0,
      status: 1
    };
  }

  closeShowDetail() {
    this.showDetail = false;
  }

  saveShowDetail() {
    console.log('保存', this.dataDetail);
    const Api = this.isAdd ? addGift : updateGift;
    Api({ ...this.dataDetail, storeId: this.companyId }).then(res => {
      this.showDetail = false;
      this.$toast('保存成功')
      this.onRefresh();
    })
  }

  getOrderList() {
    getStoreFullGift({ storeId: this.companyId })
      .then((res) => {
        this.isGetList = true;
        this.error = false;
        if (this.refreshing) {
          this.orderList = [];
        }

        const orderList = this.orderList.concat(res.data) || [];
        this.orderList = JSON.parse(JSON.stringify(orderList));
        if (Number(this.params.pageIndex) >= 1) {
          console.log("123434---------");
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .catch((err) => {
        this.error = true;
        this.params.pageIndex = 0;
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    if (this.controller) {
      this.controller.abort();
    }
    this.getOrderList();
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    console.log('1234');
    // this.loading = true
    this.params.pageIndex++;
    this.getOrderList();
  }
  showDetails(item) {
    this.dataDetail = item;
    this.showDetail = true;
  }


  upOrDown(item){
    updateGift({
      ...item,
      status: item.status == 1 ? 0 : 1
    }).then(res => {
      this.$toast(item.status == 1 ? '下架成功' : '上架成功')
      this.onRefresh()
    })
  }
  //   showGoodsList(list: any) {
  //     (this.$refs.goodsList as any).showPop(list);
  //   }
}
